import React from "react";

export default function ProfileDraw({ width = "40", height = "60" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4401 13.4281C27.3933 13.4394 34.1961 11.4036 40 7.57441C38.6886 0.408301 33.6984 2.79723e-06 33.6984 2.79723e-06H6.17973C6.17973 2.79723e-06 1.47072 0.386431 1.01717e-06 6.97862C5.98382 11.1877 13.1242 13.4407 20.4401 13.4281V13.4281Z"
        transform="translate(0 45.97)"
        fill="#EF5753"
      />
      <path
        d="M17.1757 34.3515C26.6616 34.3515 34.3515 26.6616 34.3515 17.1757C34.3515 7.68984 26.6616 0 17.1757 0C7.68984 0 0 7.68984 0 17.1757C0 26.6616 7.68984 34.3515 17.1757 34.3515Z"
        transform="translate(2.886 5.747)"
        fill="#333"
      />
      <path
        opacity="0.1"
        d="M-6.35733e-07 1.39861e-06H11.0054V8.80452C11.0054 10.2636 10.4259 11.6629 9.39443 12.6948C8.36292 13.7267 6.96382 14.3067 5.50478 14.3072V14.3072C4.04537 14.3072 2.64574 13.7275 1.61379 12.6955C0.58183 11.6636 0.00208457 10.2639 0.00208457 8.80452V1.39861e-06H-6.35733e-07Z"
        transform="translate(14.519 37.23)"
        fill="#000"
      />
      <path
        d="M0.346848 0H10.6585C10.7511 0 10.8398 0.0367632 10.9053 0.1022C10.9707 0.167638 11.0075 0.256389 11.0075 0.348932V8.80452C11.0076 9.52741 10.8653 10.2432 10.5887 10.9111C10.3121 11.579 9.90661 12.1858 9.39541 12.6969C8.8842 13.208 8.27729 13.6134 7.60937 13.8899C6.94144 14.1664 6.22558 14.3085 5.5027 14.3083V14.3083C4.04329 14.3083 2.64366 13.7285 1.6117 12.6966C0.579747 11.6646 1.39867e-06 10.265 1.39867e-06 8.80556V0.348932C-2.44161e-07 0.256749 0.0364738 0.168309 0.101461 0.102932C0.166449 0.0375538 0.254667 0.000550343 0.346848 0V0Z"
        transform="translate(14.52 36.821)"
        fill="#FDB797"
      />
      <path
        opacity="0.1"
        d="M2.79723e-06 1.32386C3.54694 2.64902 7.45124 2.65973 11.0054 1.35406V-1.52576e-06H2.79723e-06V1.32386Z"
        transform="translate(14.539 40.062)"
        fill="#000"
      />
      <path
        d="M15.7748 31.5496C24.487 31.5496 31.5496 24.487 31.5496 15.7748C31.5496 7.06262 24.487 0 15.7748 0C7.06262 0 0 7.06262 0 15.7748C0 24.487 7.06262 31.5496 15.7748 31.5496Z"
        transform="translate(4.287 10.572)"
        fill="#FDB797"
      />
      <path
        opacity="0.1"
        d="M-1.01717e-06 3.96636C-1.01717e-06 3.96636 6.64844 17.4611 25.4022 9.62425L21.0359 2.77791L13.2958 6.35733e-07L-1.01717e-06 3.96636Z"
        transform="translate(8.825 8.032)"
        fill="#000"
      />
      <path
        d="M-1.01717e-06 3.96844C-1.01717e-06 3.96844 6.64844 17.4632 25.4022 9.62425L21.0359 2.77791L13.2958 -7.6288e-07L-1.01717e-06 3.96844Z"
        transform="translate(8.825 7.832)"
        fill="#333"
      />
      <path
        d="M0.329313 10.8856C0.777589 9.49793 1.55235 8.23809 2.58851 7.21194C5.69139 4.14447 10.7785 3.49764 13.3877 5.7216e-07C14.0126 0.970758 13.5293 2.46335 12.4502 2.87998C14.95 2.86332 17.8467 2.64459 19.2601 0.588496C19.6094 1.40169 19.7208 2.29732 19.5812 3.17129C19.4416 4.04526 19.0569 4.86167 18.4716 5.52561C20.6871 5.62977 23.0546 7.12965 23.1942 9.34302C23.29 10.8179 22.3609 12.2136 21.1537 13.0594C19.9465 13.9052 18.4758 14.2937 17.0332 14.6114C12.821 15.5415 -2.41943 19.4339 0.329313 10.8856Z"
        transform="translate(8.438)"
        fill="#333"
      />
      <path
        d="M1.46759 5.50374C2.27812 5.50374 2.93519 4.27168 2.93519 2.75187C2.93519 1.23205 2.27812 0 1.46759 0C0.657064 0 0 1.23205 0 2.75187C0 4.27168 0.657064 5.50374 1.46759 5.50374Z"
        transform="translate(2.813 23.58)"
        fill="#FDB797"
      />
      <path
        d="M1.46759 5.50374C2.27812 5.50374 2.93519 4.27168 2.93519 2.75187C2.93519 1.23205 2.27812 0 1.46759 0C0.657063 0 0 1.23205 0 2.75187C0 4.27168 0.657063 5.50374 1.46759 5.50374Z"
        transform="translate(34.367 23.58)"
        fill="#FDB797"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Icons/ProfileDraw.js